'use strict';

function register(angular) {
  // Configure your React app base URL here
  const REACT_BASE_URL = '/v2/web/index.html#';

  return [function () {
    return {
      restrict: 'A',
      link: function (scope, elem, attrs) {
        function updateHref() {
          const path = attrs.reactHref || '';
          elem.attr('href', REACT_BASE_URL + path);
        }

        attrs.$observe('reactHref', updateHref);
        updateHref();
      }
    };
  }];
}

module.exports = register;
